import {
  useWSModal,
  useWSModalCustom,
  WSCard,
  WSInfoBox,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";

const ModalAbandon: React.FC<{
  onClose: () => void;
  onContinue: () => void;
}> = props => (
  <WSModal
    size="S"
    onClose={props.onClose}
    title="Exit update request"
    actions={{
      alignment: "fill",
      buttons: [
        {
          kind: "Secondary",
          label: "Cancel",
          onClick: props.onClose
        },
        {
          destructive: true,
          label: "Exit without changes",
          onClick: props.onContinue
        }
      ]
    }}
  >
    <WSText.ParagraphSm mb="L" color="gray600">
      Are you sure you want to exit the U.S. person info update?
    </WSText.ParagraphSm>
    <WSInfoBox>Any unsaved changes not submitted will be lost.</WSInfoBox>
  </WSModal>
);

export const useModalAbandon = () => useWSModalCustom(ModalAbandon);
